import React from 'react';

import { useSystemSettings } from 'providers/SystemSettingsProvider';
import Markdown from 'components/Markdown/Markdown';
import Splash from 'components/Splash/Splash';

import './SystemDisabledPage.scss';

const SystemDisabledPage = () => {
  const { logo_image, portal_name, disabled_reason } = useSystemSettings();

  return (
    <div className="enkrateia-system-disabled-page">
      <Splash>
        <div className="message">
          <img className="logo" src={logo_image} alt={portal_name} />
          <Markdown>{disabled_reason}</Markdown>
        </div>
      </Splash>
    </div>
  );
};

export default SystemDisabledPage;
